<template><section><template>
<h3>Cascader</h3>
<div class="bs-docs-section">
  <div class="bs-example">
    <n3-cascader :options="options" :on-change="selectChange" v-model="value" :select-change="true"></n3-cascader>
  </div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-cascader</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"options"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"selectChange"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">:select-change</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-cascader</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">  [{
    <span class="hljs-attr">value</span>: <span class="hljs-string">'zhejiang'</span>,
    <span class="hljs-attr">label</span>: <span class="hljs-string">'zhejiang'</span>,
    <span class="hljs-attr">children</span>: [{
      <span class="hljs-attr">value</span>: <span class="hljs-string">'hangzhou'</span>,
      <span class="hljs-attr">label</span>: <span class="hljs-string">'hangzhou'</span>,
      <span class="hljs-attr">children</span>: [{
        <span class="hljs-attr">value</span>: <span class="hljs-string">'xihu'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'xihu'</span>,
      }],
    }],
  }, {
    <span class="hljs-attr">value</span>: <span class="hljs-string">'jiangsu'</span>,
    <span class="hljs-attr">label</span>: <span class="hljs-string">'jiangsu'</span>,
    <span class="hljs-attr">disabled</span>:<span class="hljs-literal">true</span>,
    <span class="hljs-attr">children</span>: [{
      <span class="hljs-attr">value</span>: <span class="hljs-string">'nanjing'</span>,
      <span class="hljs-attr">label</span>: <span class="hljs-string">'nanjing'</span>,
      <span class="hljs-attr">children</span>: [{
        <span class="hljs-attr">value</span>: <span class="hljs-string">'zhonghuamen'</span>,
        <span class="hljs-attr">label</span>: <span class="hljs-string">'zhonghuamen'</span>,
      }],
    }],
  }]
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>options</td>
<td>Array</td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">200px</code></td>
<td>width</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
<tr>
<td>placeholder</td>
<td><code v-pre="">String</code></td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>display-render</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td></td>
</tr>
<tr>
<td>select-change</td>
<td><code v-pre="">Boolean</code></td>
<td>-</td>
<td>Whether to select to change</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>
const options = [{
  value: 'zhejiang',
  label: 'zhejiang',
  children: [{
    value: 'hangzhou',
    label: 'hangzhou',
    children: [{
      value: 'xihu',
      label: 'xihu'
    }]
  }]
}, {
  value: 'jiangsu',
  label: 'jiangsu',
  disabled: true,
  children: [{
    value: 'nanjing',
    label: 'nanjing',
    children: [{
      value: 'zhonghuamen',
      label: 'zhonghuamen'
    }]
  }]
}]

const value = ['zhejiang', 'hangzhou']

export default {
  data () {
    return {
      options: options,
      value: value
    }
  },
  methods: {
    selectChange (selectedValue) {
      console.log(this.value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3CascaderDocs.md?83766b90